// This file was auto-generated by Fern from our API Definition.
export const FetchTestsetRevisionToFileRequestFileType = {
    Csv: "csv",
    Json: "json",
};
